define('shared/lib/beam',['node_modules/beam/beam', '$'], function( Beam, $ ){
    return new Beam( $ );
} ); 
